export enum StallActionTypes {
    API_RESPONSE_SUCCESS = '@@stall/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@stall/API_RESPONSE_ERROR',

    GET_STALLS = '@@stall/GET_STALLS',
    GET_STALL_BY_ID = '@@stall/GET_STALL_BY_ID',
    ADD_STALL = '@@stall/ADD_STALL',
    UPDATE_STALL = '@@stall/UPDATE_STALL',
    DELETE_STALL = '@@stall/DELETE_STALL',

    BULK_IMPORT_STALLS = '@@stall/BULK_IMPORT_STALLS',
    RESET_IMPORT_STATE = '@@stall/RESET_IMPORT_STATE',

    RESET = '@@stall/RESET',
}